import React from 'react';
import './StreakFlame.css';

/**
 * Flame badge for a player's Generic Share daily streak.
 *
 * Purely presentational — it renders whatever it is handed and never fetches.
 * StreakHelper owns the data; Farm2Feeds owns the state.
 *
 * Renders nothing at all when there is no streak, so an avatar with no streak
 * looks exactly as it did before this feature existed.
 *
 * Tiers mirror ShareStreakManager::getFlameTier() on the server:
 *   1 => 1-6 days     small orange
 *   2 => 7-29 days    bold orange
 *   3 => 30-99 days   deep red
 *   4 => 100+ days    gold
 *
 * A streak whose grace window is open (the player missed a day and can still
 * save it) renders in an "at risk" variant rather than disappearing.
 *
 * @param {object} props
 * @param {object} props.streak { currentStreak, flameTier, graceActive }
 * @param {string} props.extraClass optional extra class for placement variants
 */
function StreakFlame(props) {
    const streak = props.streak;

    if (!streak) {
        return null;
    }

    const count = streak.currentStreak ? parseInt(streak.currentStreak, 10) : 0;
    if (!count || count < 1) {
        return null;
    }

    // Trust the server's tier, but fall back to deriving it so a badge never
    // renders untiered (and therefore unstyled) if the field is ever missing.
    let tier = streak.flameTier ? parseInt(streak.flameTier, 10) : 0;
    if (!tier) {
        tier = count <= 6 ? 1 : (count <= 29 ? 2 : (count <= 99 ? 3 : 4));
    }

    const atRisk = streak.graceActive === true;
    const label = atRisk
        ? count + " day streak, at risk today"
        : count + " day share streak";
    const badgeBasePath = process.env.REACT_APP_ASSET_PATH + "/games/farm2/streak/";
    const badgeImage = badgeBasePath + (atRisk ? "badge_0.png" : "badge_" + tier + ".png");

    const classes = [
        "farm2-streak-flame",
        "farm2-streak-tier-" + tier,
        atRisk ? "farm2-streak-at-risk" : "",
        props.extraClass || ""
    ].filter(Boolean).join(" ");

    return (
        <span className={classes} title={label} aria-label={label}>
            <img className="farm2-streak-flame-image" src={badgeImage}
                alt="" aria-hidden="true" />
            <span className="farm2-streak-flame-count">{count}</span>
            {atRisk &&
                <img className="farm2-streak-flame-warning"
                    src={badgeBasePath + "badge_00.png"} alt="" aria-hidden="true" />}
        </span>
    );
}

export default StreakFlame;
